import React from "react";
import Layout from "../../routes/Layout";
import { CalenderIcon, CheckoutIcon, UserIcon } from "../../assets/Icons";

const Main = () => {
  const blogList = [
    {
      img: "images/blog1.png",
      title: "Services that printing at you is important",
      btnTitle: "Workspace",
    },
    {
      img: "images/blog2.png",
      title: "That will help you get 1% better every day",
      btnTitle: "Business Tips",
    },
    {
      img: "images/blog3.png",
      title: "A checklist to improve your daily routine",
      btnTitle: "Coding",
    },
    {
      img: "images/blog4.png",
      title: "Services that printing at you is important",
      btnTitle: "Workspace",
    },
  ];
  return (
    <Layout>
      <div className="lading-page bg-[#212020] min-h-screen flex flex-col w-full">
        <div className="wrap wrapWidth flex flex-col ">
          <div className="flex flex-col items-center w-full gap-14">
            <div className="flex flex-col items-center gap-4">
              <h1
                data-aos="fade-up"
                className="text-white font-semibold sm:text-4xl text-2xl text-center sm:w-[65%] mb-4"
              >
                SmartTract: Your Aid to{" "}
                <span className="text-g">Unlock Your Potential</span> and Boost
                Your Inner Confidence{" "}
              </h1>
              <p
                data-aos="fade-up"
                className="text-[#BABABA] text-xs font-light text-center sm:w-[68%]"
              >
                Create your own tailored PE exercises designed to maximize your
                gains. With Smart Track, you can create your own workout
                routine, monitor your progress, stay motivated, and remain
                accountable to your goals. Our innovative system ensures you
                achieve the results you desire, helping you stay on track every
                step of the way. Unlock your potential and boost your confidence
                with personalized workouts that adapt to your needs.
              </p>
              <button
                data-aos="flip-up"
                className="btn themeColor text-black capitalize text-sm px-3"
              >
                Download Now
              </button>
            </div>
            <img
              data-aos="flip-left"
              src="./images/hero-bg.webp"
              className="md:h-[700px] sm:h-[400px] h-[260px]"
            />
          </div>
          <div className="flex gap-6 py-12 sm:flex-row flex-col-reverse">
            <div className="flex flex-1">
              <img
                data-aos="flip-right"
                src="./images/TV1.png"
                className="sm:h-[400px] h-[300px]"
              />
            </div>
            <div className="flex flex-1 flex-col gap-6">
              <h1
                data-aos="fade-up"
                className="text-white font-medium text-3xl"
              >
                Targeted PE <span className="text-g"> Workouts</span>
              </h1>
              <p
                data-aos="fade-up"
                className="text-white text-sm font-extralight"
              >
                Unlock Your Potential with Targeted PE Workout Routines
              </p>
              <p
                data-aos="fade-up"
                className="text-white text-sm font-extralight"
              >
                Create your own tailored exercises designed to maximize your
                gains and enhance your confidence. Elevate your regimen with
                Smarttract’s expertly crafted workout routine builder for PE.
                Start your journey to a more confident you today
              </p>
              <div data-aos="fade-up" className="flex flex-col gap-3">
                <div className="flex items-center gap-2">
                  <div className="flex items-center justify-center h-3 w-3">
                    <CheckoutIcon />
                  </div>
                  <p className="text-white text-sm font-extralight">
                    Use predefined workout routine
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex items-center justify-center h-3 w-3">
                    <CheckoutIcon />
                  </div>
                  <p className="text-white text-sm font-extralight">
                    Create your own personalized workout routine
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-black/90 flex w-full py-12">
          <div className="wrap wrapWidth flex flex-col gap-12 ">
            <div className="flex gap-6 sm:flex-row flex-col">
              <div data-aos="fade-up" className="flex flex-1 flex-col gap-6">
                <h1 className="text-white font-medium sm:text-3xl text-xl sm:w-[60%] w-full">
                  Track
                  <span className="text-g"> Progress</span>, Reach Your Goals
                </h1>

                <p className="text-white text-xs font-extralight">
                  Say goodbye to time-watching! Let the SmartTract app handle
                  it, so you can focus on what truly matters’
                </p>
                <p className="text-white text-xs font-extralight">
                  Effortlessly log and view each day's completed exercises,
                  ensuring you remain on course with your personal goals. With
                  seamless integration into your daily routine, Smarttract
                  empowers you to monitor your progress and celebrate your
                  achievements every step of the way. Whether you're focusing on
                  growth or endurance, Smarttract is your dedicated companion in
                  your enhancement journey.
                </p>
                <div className="flex flex-col gap-3">
                  <div className="flex items-center gap-2">
                    <div className="flex items-center justify-center h-3 w-3">
                      <CheckoutIcon />
                    </div>
                    <p className="text-white text-sm font-extralight">
                      No more constantly checking the clock
                    </p>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="flex items-center justify-center h-3 w-3">
                      <CheckoutIcon />
                    </div>
                    <p className="text-white text-sm font-extralight">
                      Focus on what truly matters
                    </p>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="flex items-center justify-center h-3 w-3">
                      <CheckoutIcon />
                    </div>
                    <p className="text-white text-sm font-extralight">
                      View your progress on various parameters
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex flex-1 justify-end">
                <img
                  data-aos="flip-right"
                  src="./images/TV2.png"
                  className="sm:h-[380px] h-[300px]"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="wrap wrapWidth flex flex-col gap-12">
          <div className="flex gap-6 py-12 sm:flex-row  flex-col-reverse">
            <div data-aos="flip-left" className="flex flex-1">
              <img src="./images/TV3.png" className="sm:h-[400px] h-[300px]" />
            </div>
            <div data-aos="fade-up" className="flex flex-1 flex-col gap-6">
              <h1 className="text-white font-medium text-3xl">
                Encryption that <span className="text-g"> Empowers</span>
              </h1>
              <p className="text-white text-sm font-extralight leading-8">
                Your privacy is paramount to Smarttract. Within our application,
                all user data and images undergo robust encryption processes in
                your device, rendering them unreadable to anyone without the
                proper authorization. This ensures that your personal
                information remains confidential and inaccessible to
                unauthorized parties. Rest assured, only authorized personnel
                with the requisite access credentials can decrypt and access
                this data, further reinforcing our commitment to safeguarding
                your privacy and security.
              </p>
              <div className="flex flex-col gap-3">
                <div className="flex items-center gap-2">
                  <div className="flex items-center justify-center h-3 w-3">
                    <CheckoutIcon />
                  </div>
                  <p className="text-white text-sm font-extralight">
                    You have option to save your encrypted data in server
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex items-center justify-center h-3 w-3">
                    <CheckoutIcon />
                  </div>
                  <p className="text-white text-sm font-extralight">
                    Only you can see your data even in server or in local device
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-black/90 flex w-full py-12">
          <div className="wrap wrapWidth flex flex-col gap-12 ">
            <div className="flex gap-6 sm:flex-row flex-col">
              <div data-aos="fade-up" className="flex flex-1 flex-col gap-6">
                <h1 className="text-white font-medium text-3xl sm:w-[60%] w-full capitalize">
                  Login made
                  <span className="text-g"> Easy</span>
                </h1>

                <p className="text-white text-sm font-extralight leading-7">
                  Smarttract offers a multifaceted approach to user
                  authentication, ensuring both security and convenience. With
                  support for biometric login, users can effortlessly access
                  their accounts using fingerprint or facial recognition,
                  providing a seamless and secure experience. Alternatively,
                  users have the option to utilize a PIN code for quick access,
                  or opt for traditional email/password login for added
                  flexibility. Whatever the preference, Smarttract empowers
                  users with multiple authentication methods, enhancing security
                  while accommodating individual preferences and needs
                </p>
              </div>
              <div data-aos="flip-right" className="flex flex-1 justify-end">
                <img src="./images/TV4.png" className="h-[380px]" />
              </div>
            </div>
          </div>
        </div>
        <div className="get-start-section flex w-full py-12">
          <div className="wrap wrapWidth flex flex-col gap-12 ">
            <div data-aos="fade-up" className="bg sm:flex hidden p-12">
              <div className="flex flex-[0.8]"></div>
              <div className="flex flex-1 flex-col gap-2 relative">
                <h4 className="text-black text-sm font-medium">
                  READY TO GET STARTED?
                </h4>
                <h4 className="text-black text-3xl font-medium">
                  Smarttract Unlock Your Potential and improve confidence
                </h4>
                <div className="flex items-center gap-5 absolute bottom-0">
                  <a href="" target="_blank">
                    <img
                      src="./images/playStore.png"
                      className="h-[40px] w-full"
                    />
                  </a>
                  <a href="" target="_blank">
                    <img
                      src="./images/appStore.png"
                      className="h-[40px] w-full"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="bg2 sm:hidden flex p-6">
              <div
                data-aos="fade-up"
                className="flex w-full flex-col gap-2 relative"
              >
                <h4
                  data-aos="fade-up"
                  className="text-black text-sm font-medium"
                >
                  READY TO GET STARTED?
                </h4>
                <h4
                  data-aos="fade-up"
                  className="text-black sm:text-3xl text-2xl font-medium"
                >
                  Smarttract Unlock Your Potential and improve confidence
                </h4>
                <div className="flex items-center gap-5 absolute bottom-0">
                  <a href="" target="_blank">
                    <img
                      src="./images/playStore.png"
                      className="h-[40px] w-full"
                    />
                  </a>
                  <a href="" target="_blank">
                    <img
                      src="./images/appStore.png"
                      className="h-[40px] w-full"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="articles-section flex flex-col w-full items-center py-12 gap-10">
              <div className="flex flex-col items-center justify-center gap-3">
                <h5 className="text-sm text-g font-medium">Latest Articles</h5>
                <h1 className="text-white sm:text-3xl text-2xl font-medium text-center">
                  Recent Studies & Publications
                </h1>
              </div>
              <div className="w-full grid md:grid-cols-4 sm:grid-cols-3 grid-cols-1 gap-4">
                {blogList.map((item, index) => (
                  <div
                    key={index}
                    className="bg-black/20 rounded-xl p-4 flex flex-col gap-5"
                  >
                    <div
                      className="blog-bg relative"
                      style={{ backgroundImage: `url(${item.img})` }}
                    >
                      <div className="absolute bottom-[-10px] left-0">
                        <button className="btn bg-white capitalize rounded-full px-3 text-black text-sm">
                          {item.btnTitle}
                        </button>
                      </div>
                    </div>
                    <h1 className="text-white sm:text-xl text-sm font-medium">
                      {item.title}
                    </h1>
                    <div className="flex items-center gap-3">
                      <div className="flex items-center gap-2">
                        <div className="flex items-center justify-center h-3 w-3">
                          <UserIcon />
                        </div>
                        <h6 className="text-white text-xs">By Admin</h6>
                      </div>
                      <div className="border-r border-white/40 h-3" />
                      <div className="flex items-center gap-2">
                        <div className="flex items-center justify-center h-3 w-3">
                          <CalenderIcon />
                        </div>
                        <h6 className="text-white text-xs">
                          February 11, 2024
                        </h6>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="contact-us flex rounded-xl gap-8 sm:flex-row flex-col">
              <div className="flex flex-[0.6]">
                <div className="themeColor p-10 flex-col w-full gap-12 rounded-xl">
                  <h1
                    data-aos="fade-up"
                    className="text-black font-medium text-3xl mb-4"
                  >
                    Let's talk with us
                  </h1>
                  <p
                    data-aos="fade-up"
                    className="text-sm text-black font-light leading-6"
                  >
                    Questions, comments, or suggestions? Simply fill in the form
                    and we’ll be in touch shortly.
                  </p>
                </div>
              </div>
              <div className="flex flex-1 flex-col w-full gap-8">
                <div className="flex items-center w-full gap-8 sm:flex-row flex-col">
                  <div className="flex flex-col sm:flex-1 w-full">
                    <label className="text-[#8D8D8D] text-sm font-normal">
                      First Name
                    </label>
                    <input
                      type="text"
                      className="bg-transparent w-full border-b border-[#8D8D8D] focus:border-white text-white"
                    />
                  </div>
                  <div className="flex flex-col sm:flex-1 w-full">
                    <label className="text-[#8D8D8D] text-sm font-normal">
                      Last Name
                    </label>
                    <input
                      type="text"
                      className="bg-transparent w-full border-b border-[#8D8D8D] focus:border-white text-white"
                    />
                  </div>
                </div>
                <div className="flex flex-col flex-1">
                  <label className="text-[#8D8D8D] text-sm font-normal">
                    Email
                  </label>
                  <input
                    type="email"
                    className="bg-transparent w-full border-b border-[#8D8D8D] focus:border-white text-white"
                  />
                </div>
                <div className="flex flex-col flex-1">
                  <label className="text-[#8D8D8D] text-sm font-normal">
                    Message
                  </label>
                  <input
                    type="text"
                    className="bg-transparent w-full border-b border-[#8D8D8D] focus:border-white text-white"
                  />
                </div>
                <div className="flex items-center justify-end mt-5">
                  <button className="btn themeColor text-black">
                    Send Message
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <Modal open={open} onClose={() => setOpen(false)}>
          <TableRowModel setOpen={setOpen} item={modelData} />
        </Modal> */}
      </div>
    </Layout>
  );
};

export default Main;
